// Diagnostics
export const DIAGNOSTICS_TABLE_PAGE_SIZES = [10, 15, 20, 30];
export const DIAGNOSTICS_TABLE_COLUMNS = ['srNo', 'link'];

export const DIAGNOSTICS_VIDEO_TABLE_PAGE_SIZES = [10, 15, 20, 30];
export const DIAGNOSTICS_VIDEO_TABLE_COLUMNS = ['srNo', 'link', 'download'];
